(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EtaskUiTemp", [], factory);
	else if(typeof exports === 'object')
		exports["EtaskUiTemp"] = factory();
	else
		root["EtaskUiTemp"] = factory();
})(Object(typeof self !== 'undefined' ? self : this), () => {
return 